module.exports = __webpack_public_path__ + "static/media/serenedry-3.4db889f2.png";